(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hide-whatsapp-on-menu"] && !Shopify.designMode) return;
  try {
    (function() {
    var MENU_SUMMARY_SELECTOR = '#Details-menu-drawer-container > summary[aria-controls="menu-drawer"]';
    var WHATSAPP_SELECTOR = '.gty-wacb-wrapper';

    function updateWhatsappVisibility() {
      var summary = document.querySelector(MENU_SUMMARY_SELECTOR);
      var whatsapp = document.querySelector(WHATSAPP_SELECTOR);

      if (!summary || !whatsapp) return;

      var isExpanded = summary.getAttribute('aria-expanded') === 'true';
      whatsapp.style.display = isExpanded ? 'none' : '';
    }

    function onReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    onReady(function() {
      updateWhatsappVisibility();

      var summary = document.querySelector(MENU_SUMMARY_SELECTOR);
      if (!summary) return;

      summary.addEventListener('click', function() {
        window.requestAnimationFrame(updateWhatsappVisibility);
      });

      var details = document.getElementById('Details-menu-drawer-container');
      if (details) {
        details.addEventListener('toggle', updateWhatsappVisibility);
      }

      var observer = new MutationObserver(function(mutations) {
        var shouldUpdate = mutations.some(function(mutation) {
          return mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded';
        });
        if (shouldUpdate) updateWhatsappVisibility();
      });

      if (summary) {
        observer.observe(summary, { attributes: true, attributeFilter: ['aria-expanded'] });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
